module.exports = __webpack_public_path__ + "static/media/chart_widget_icon.74746fa5.svg";